/* RESPONSIBLE TEAM: team-ai-agent-2 */
import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';

class AutomationFinAIAgentReleaseRoute extends Route {
  @service declare intl: IntlService;

  analytics = {
    section: 'automation',
    place: 'fin-ai-agent.releases.release',
  };

  get titleToken() {
    return this.intl.t('ai-agent.new-submenu.releases');
  }

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(AutomationFinAIAgentReleaseRoute, { overrideRenderTemplate: false });
